import { Component, inject, Signal } from '@angular/core';
import { FilterOutputService } from '../services/filter-output.service';
import { ResponsiveService } from '../services/responsive.service';
import { SettingsService } from '../services/settings.service';
import { appName, assetBaseUrl, displayDomainName, domainName, gameName, imgPrefix, poe1, poe2 } from '../../game';
import { RuleId } from '../models/rule-id';

@Component({
  template: ''
})
export abstract class BaseComponent {
  readonly poe1 = poe1;
  readonly poe2 = poe2;
  readonly isMobile: Signal<boolean>;
  readonly assetBaseUrl = assetBaseUrl;
  readonly imgPrefix = imgPrefix;
  readonly appName = appName;
  readonly gameName = gameName;
  readonly domainName = domainName;
  readonly displayDomainName = displayDomainName;

  protected readonly settings = inject(SettingsService);
  protected readonly filterOutputService = inject(FilterOutputService);

  protected get navigationEnabled(): boolean {
    return this.settings.enableRuleNavigation();
  }

  constructor() {
    const responsiveService = inject(ResponsiveService);
    this.isMobile = responsiveService.isMobile;
  }

  navigateToRule(rule: RuleId, event: MouseEvent) {
    if (!this.navigationEnabled) return;

    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      event.stopPropagation();

      this.filterOutputService.ensureFormattedFilterText();
      setTimeout(() => {
        const filterOutputDiv = document.querySelector('#filter-output') as HTMLElement;
        if (!filterOutputDiv) return;

        const ruleSpan = filterOutputDiv.querySelector(`span[data-rule-id="${rule}"]`) as HTMLElement;
        if (!ruleSpan) return;

        ruleSpan.scrollIntoView({ behavior: 'smooth', block: 'center' });
        ruleSpan.classList.add('highlighted');
        setTimeout(() => ruleSpan.classList.remove('highlighted'), 2000);
      }, 0);
    }
  }
}
